import * as React from 'react';
import { Button } from 'reactstrap';
import DataTable, { IDataTableColumn } from 'react-data-table-component';
import { times } from 'lodash';
import { useHistory } from 'react-router';
import { tableLoading, tableLoadingButton } from 'src/modules/Alert/ControlCenter/utils/placeholders';
import { IManager, ManagerUserTypes, ManagersTypes } from 'src/share/types/manager';
import Routes from 'src/modules/Routing/routes';
import UserTableSubHeader from './UserTableSubHeader';
import useDebounce from 'src/share/hooks/useDebounce';

interface ITableUsers extends IManager {
  userType: string;
  view: JSX.Element;
}

interface IUserTableProps {
  loading: boolean;
  users: IManager[];
  total: number;
  onSizeChanged: (size: number, page: number) => void;
  onPageChanged: (page: number) => void;
  onTextChanged: (text: string) => void;
  onSort: (column: IDataTableColumn, sortDirection: string) => void;
}

export const getUserTypeByAgencyCode = (agencyCode: string): string => {
  return Object.keys(ManagerUserTypes).find(userType => ManagerUserTypes[userType] === agencyCode)|| ManagersTypes.CASEMANAGER;
}

const columns = (isLoading: boolean) => [
  { name: 'Username', witdh: '250px', sortable: true, ...tableLoading('name', isLoading, 60) },
  { name: 'Email', sortable: true, width: '250px', ...tableLoading('email', isLoading, 80) },
  { name: 'User Type', ...tableLoading('userType', isLoading, 60) },
  { name: 'Agency code', sortable: true, ...tableLoading('agencyCode', isLoading, 60) },
  { name: 'Address', sortable: true, ...tableLoading('address', isLoading, 80) },
  { name: 'Actions', width: '180px', ...tableLoadingButton('view', isLoading, 'View') },
];

const UsersTable = (props: IUserTableProps): React.ReactElement => {
  const { loading, users, total, onSizeChanged, onPageChanged, onTextChanged, onSort } = props;
  const [ filterText, setFilterText] = React.useState("");
  const debouncedSFilterText = useDebounce(filterText, 500);
  const history = useHistory();
  const loadingArray = React.useRef(times(10, Object));
  const tableUsers: ITableUsers[] = users.map((user) => ({
    ...user,
    userType: getUserTypeByAgencyCode(user.agencyCode),
    view:
      <Button
        className="btn btn-blue float-right"
        onClick={() => history.push(Routes.ADMINUSERSINFO.replace(':managerId', user.managerId))}
      >
        View
      </Button>
  }));
  React.useEffect(() => {
    onTextChanged(debouncedSFilterText);
  }, [debouncedSFilterText]);
  return (
    <DataTable
      columns={columns(loading)}
      data={loading ? loadingArray.current : tableUsers}
      highlightOnHover={true}
      className="data-table__container"
      fixedHeader={true}
      noHeader={true}
      subHeader={true}
      subHeaderComponent={<UserTableSubHeader filterText={filterText} onSearch={setFilterText} />}
      pagination={true}
      paginationServer={true}
      paginationTotalRows={total}
      sortServer={true}
      onSort={onSort}
      onChangeRowsPerPage={onSizeChanged}
      onChangePage={onPageChanged}
    />
  );
}

export default React.memo(UsersTable);
